/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React from 'react'
import { connect } from 'react-redux'

import { formatDollars } from 'app/utils/fieldUtils'

const RefundTotals = ({ totalRefunds, totalAmount }) => (
  <div>
    <h4>{totalRefunds} Records</h4>
    Refund sum amount: {totalAmount}
  </div>
)

const mapStateToProps = state => ({
  totalRefunds: state.fundingFee?.refundsInfo?.totalRefunds,
  totalAmount: `$${formatDollars(state.fundingFee?.refundsInfo?.totalAmount)}`
})

export default connect(mapStateToProps)(RefundTotals)
